import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FaviconServiceService {

  private renderer: Renderer2;

  constructor(rendererFactory: RendererFactory2) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  setFavicon(faviconUrl: string) {
    const link: HTMLLinkElement | null = document.querySelector("link[rel*='icon']");

    if (link) {
      this.renderer.setAttribute(link, 'href', faviconUrl);
    } else {
      const newLink = this.renderer.createElement('link');
      this.renderer.setAttribute(newLink, 'rel', 'icon');
      this.renderer.setAttribute(newLink, 'href', faviconUrl);
      this.renderer.appendChild(document.head, newLink);
    }
  }
}
